import c from '../common';

export default {
  "recordId": "Record ID",
  "orderTime": "Ordering Time",
  "status": c.status.en,
  "orderType": "Order Type",
  "district": "District",
  "deliveryDistrict": "Delivery District",
  "deliveryAddress": "Delivery Address",
  "deliveryDate": "Delivery Date",
  "options": "Product",
  "customer": "Contact Person",
  "customerTel": "Contact Person Telephone",


  "detail": "Detail",
  "ordered": "Ordered",


  //DB data
  "morning": "Morning",
  "afternoon": "Afternoon",
  "IN_STORE_REDEEM": "Store Redemption",
  "DELIVERY_REDEEM": "Delivery"
};